import { useContext, createContext, ReactNode } from 'react';

import wlConfig from '../constants/wlConfig';
import { TWlConfig } from '../interfaces/wlConfig.interface';

import { getComputed } from './tenant';

type TWlConfigContextValue = {
  wlConfig: TWlConfig;
  tenant: {
    is: ReturnType<typeof getComputed>;
    name: TWlConfig['tenantDisplayName'];
  };
};

const getContextValue = (config = wlConfig) => ({
  wlConfig: config,
  tenant: {
    is: getComputed(config),
    name: config.tenantDisplayName,
  },
});

const WhitelabelContext = createContext<TWlConfigContextValue>(
  getContextValue()
);

export function useWhitelabelConfig() {
  return useContext(WhitelabelContext);
}

export function WhitelabelConfigProvider({
  children,
  config,
}: {
  children: ReactNode;
  config: TWlConfig;
}) {
  return (
    <WhitelabelContext.Provider value={getContextValue(config)}>
      {children}
    </WhitelabelContext.Provider>
  );
}
